module.exports = __webpack_public_path__ + "static/media/img_18.c5c4ca91.png";